export default "__VITE_ASSET__BODUdyVI__"